import util from "../util";

/** labs and treatments for one (legacy-model) case, as buildInfectionNoteText / buildResolutionNoteText take them */
export async function loadInfectionNoteData(http, infectionCase) {
  const client = infectionCase.client;
  const symptomDetailId = infectionCase.id;
  const labs = await http.get(`${window.CONFIG.legacy_facade_api}/symptomDetail/${symptomDetailId}/labs`).then(response => response.body);
  const treatmentConfig = await http.get(`${window.CONFIG.treatement_api}/config`).then(resp => resp.json());
  const meds = util.arrayToObj(treatmentConfig.medications, "id");
  const treatments = await http
    .get(`${window.CONFIG.treatement_api}/prescriptions`, {
      params: {
        clientId: client.id,
        symptomDetailId
      }
    })
    .then(resp => resp.json())
    .then(json => json.content)
    .then(arr =>
      arr.map(treatment => {
        const { frequency, dosage, medicationId, startDate, endDate } = treatment;
        const medication = meds[medicationId]?.displayText;
        return {
          displayText: `${medication || ""} ${dosage || ""} ${frequency || ""}`.trim(),
          startDate,
          endDate
        };
      })
    );
  return { labs, treatments };
}

/** precaution_api rows linked to the case */
export async function loadCasePrecautions(http, infectionCase) {
  // same request as ResolveInfectionCase.hasActivePrecautions
  return http
    .get(window.CONFIG.precaution_api, {
      params: {
        clientId: infectionCase.client.id,
        symptomDetailId: infectionCase.id
      }
    })
    .then(resp => resp.json())
    .then(json => json.content);
}
